import React from "react";

// Converts the stored HTML passage into plain text and renders real <br/>
// line-break elements. We intentionally do NOT rely on CSS `white-space:
// pre-line` to turn "\n" into visible breaks, because that rendering path is
// not honored consistently in some embedded browsers (e.g. Safe Exam Browser).
// Emitting actual <br/> elements works the same everywhere.
export const formatText = (html) => {
  if (!html) return "";

  const text = String(html)
    // Block-level / line-break tags become newlines.
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(div|p|li|h[1-6]|tr)>/gi, "\n")
    .replace(/<li[^>]*>/gi, "\n")
    // Drop every remaining tag.
    .replace(/<[^>]*>/g, "")
    // Decode the most common HTML entities.
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    // Normalize newlines. Keep every break so consecutive empty lines
    // (e.g. several <div><br></div>) are preserved as-is.
    .replace(/\r\n?/g, "\n");

  const lines = text.split("\n");

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </React.Fragment>
  ));
};
